<template>
    <v-form v-model="formValido" ref="formInterno">
            <v-card>
                <v-card-title>
                    Emitente
                </v-card-title>
                <v-card-text>
                    <div>
                        <v-row>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.cpfOrCnpjEmitente" v-mask="'##.###.###/####-##'"
                                    clearable outlined label="CNPJ/CPF" @blur="getCnpjInfo(objNf.cpfOrCnpjEmitente, 'Emitente')"
                                    :rules="[v => !!v || 'Emitente é obrigatório']" 
                                />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                            <v-text-field v-model="objNf.razaoSocialNomeEmitente" clearable outlined
                                label="Razão Social/Nome" :rules="[v => !!v || 'Razão Social é obrigatório']" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.inscricaoMinucipal" clearable outlined
                                    label="Inscrição Municipal" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.localEmissao" clearable outlined label="Local de Emissão" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.emitenteLogradouro" clearable outlined label="Logradouro" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.emitenteBairro" clearable outlined label="Bairro" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.emitenteCodCidade" clearable outlined label="Código da Cidade" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-combobox 
                                    v-model="objNf.enqServico" 
                                    :items="['MEI', 'Simples Nacional', 'Lucro Presumido', 'Lucro Real']"
                                    clearable outlined label="Tipo de Enquadramento" 
                                />
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>

            <v-card class="mb-5 mt-5">
                <v-card-title>
                    Tomador do Serviço
                </v-card-title>

                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="3">
                            <v-autocomplete
                                clearable outlined label="Cliente" 
                                v-model="objNf.destinatario" 
                                :items="clientes" 
                                item-value="id"
                                item-text="nomeFantasia"
                                return-object
                                @change="onSelectedClienteChange"
                                disabled
                            />
                        </v-col>

                        <v-col cols="3">
                            <v-text-field v-model="objNf.cpfOrCnpjTomador" v-mask="'##.###.###/####-##'" clearable
                                outlined readonly label="CNPJ/CPF"
                                :rules="[v => !!v || 'CNPJ é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.razaoSocialNomeTomador" clearable outlined
                                readonly label="Razão Social/Nome" :rules="[v => !!v || 'Razão Social é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.inscricaoMinucipalTomador" clearable outlined
                                readonly label="Inscrição Municipal"
                                 />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field readonly v-model="objNf.endereco" clearable outlined label="Endereço Completo"
                                :rules="[v => !!v || 'Endereço é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.codigoCidade" clearable outlined label="Código da Cidade"
                                readonly
                                :rules="[v => !!v || 'Código é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorUf" clearable outlined label="UF"
                                readonly
                                :rules="[v => !!v || 'UF é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorNumero" clearable outlined readonly label="Número" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorComplemento" clearable outlined readonly label="Complemento" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorCep" clearable outlined label="CEP"
                                readonly
                                :rules="[v => !!v || 'CEP é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorEmail" clearable outlined label="E-mail"
                                :rules="[v => !!v || 'E-mail é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.localRecebimento" clearable outlined
                                label="Local do Recebimento" />
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>

            <v-card>
                <v-card-title>
                    Job
                </v-card-title>

                <v-card-text>
                    <v-autocomplete 
                        v-model="objNf.job" 
                        :items="projects" 
                        item-text="code" 
                        item-value="id"
                        label="JOB" 
                        dense 
                        outlined
                        @change="selectedJob"
                        return-object
                    >
                    </v-autocomplete>

                    <v-data-table
                        v-model="objNf.jobItens"
                        :headers="headers"
                        :items="dataItensJob"
                        class="elevation-1"
                        disable-sort
                        hide-default-footer
                        show-select 
                        single-select
                        color="primary"
                        return-object
                    >
                        <template v-slot:item.precoUnitario="{ item }">
                            <span>{{ formatCurrencyFromNumber(item.precoUnitario) }}</span>
                        </template>

                        <template v-slot:item.precoTotal="{ item }">
                            <span>{{ formatCurrencyFromNumber(item.precoTotal) }}</span>
                        </template>
                    </v-data-table>

                    <v-row class="mt-5">
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-money="money" 
                                clearable outlined 
                                label="Valor da Nota"
                                v-model="objNf.valorNf" 
                                :readonly="true"
                                :key="updtaeSum"
                            />
                        </v-col>
                        
                        <v-col cols="12" sm="6" md="2">
                            <v-text-field 
                                v-money="money" 
                                clearable outlined 
                                label="Base Calculo"
                                v-model="objNf.baseCalculo" 
                                :key="updtaeSum"
                            />
                        </v-col>

                        <v-col cols="12" sm="6" md="2">
                            <v-select 
                                :items="aliquoataOptions" 
                                clearable 
                                outlined
                                label="Aliquota(%)"
                                v-model="objNf.aliquota"
                                item-text="text"
                                item-value="value"
                                @change="onAliquotaChange"
                            />
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                            <v-text-field 
                                v-money="money" 
                                clearable outlined
                                label="Imposto"
                                v-model="objNf.imposto"
                            />
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                            <v-text-field 
                                v-money="money" 
                                clearable outlined
                                label="Dedutivel"
                                v-model="objNf.dedutivel"
                            />
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>

        <div class="mb-5 mt-5" style="width: 100%">
            <v-card>
                <v-card-title>
                    Parcelas - {{ sumParcelas()?.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' }) }} - {{ formatCurrencyFromCents(objNf.valorNf || valorNf) }}
                </v-card-title>

                <div>
                <v-row dense v-for="parcela in parcelas" :key="parcela.numParcela">
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field clearable outlined label="N° Parcela" v-model="parcela.numParcela" readonly />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field clearable outlined label="Data de Vencimento" type="date" v-model="parcela.vencimento" />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            :rules="[
                                v => {
                                    const valor = toIntegerMoney(objNf.valorNf)
                                    return valor >= sumParcelasInCents() || 'Não pode ultrapassar o valor da nota'
                                }
                            ]"
                            clearable outlined label="Valor da Parcela" 
                            v-money="money" 
                            v-model="parcela.vrlParcela" 
                        />
                    </v-col>

                    <!-- Botão com ícone ao final -->
                    <v-col cols="12" sm="6" md="4" >
                        <v-btn color="primary" icon @click="addParcela()">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn color="error" icon @click="removeParcela(parcela)">
                            <v-icon>mdi-minus</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                </div>

            </v-card>
        </div>
            

            <v-card>
                <v-card-title>
                    Serviço Prestado
                </v-card-title>

                <v-card-title :key="componentKey">
                    <v-row dense>
                        <v-col cols="12" sm="6" md="3">
                            <v-autocomplete
                                :rules="[v => !!v || 'CNAE é obrigatório']"
                                v-model="objNf.cnae"
                                :items="cnaeList"
                                item-text="codigo"
                                item-value="id"
                                label="CNAE"
                                dense
                                outlined
                            >
                                <template v-slot:item="{ item }">
                                    <div class="d-flex flex-column">
                                        <div class="font-weight-bold">{{ item.codigo }}</div>
                                        <div>{{ item.descricao }}</div>
                                    </div>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-autocomplete
                                v-model="objNf.enquadramento"
                                :items="enquadramentoList"
                                item-text="servicoDescricao"
                                item-value="id"
                                label="Enquadramento"
                                dense
                                outlined
                                :rules="[v => !!v || 'Enquadramento é obrigatório']"
                                :disabled="!objNf.cnae"
                                @change="onEnquadramentoChange"
                            >
                                <template v-slot:item="{ item }">
                                    <div class="d-flex flex-column">
                                        <div class="font-weight-bold">{{ item.servicoCodigo }}</div>
                                        <div>{{ item.servicoDescricao }}</div>
                                    </div>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-autocomplete
                                v-model="objNf.cest"
                                :items="cestOptions"
                                item-text="descricao"
                                item-value="id"
                                label="CEST"
                                dense
                                outlined
                                :rules="[v => !!v || 'CEST é obrigatório']"
                                :disabled="!objNf.enquadramento"
                            >
                                <template v-slot:item="{ item }">
                                    <div>{{ item.codigo }} - {{ item.descricao }}</div>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span>{{ item.codigo }} - {{ item.descricao }}</span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-autocomplete
                                v-model="objNf.nbs"
                                :items="nbsOptions"
                                item-text="nbsDescricao"
                                item-value="id"
                                label="NBS"
                                dense
                                outlined
                                :rules="[v => !!v || 'NBS é obrigatório']"
                                :disabled="!objNf.cest"
                            >
                                <template v-slot:item="{ item }">
                                    <div>{{ item.nbsCodigo }} - {{ item.nbsDescricao }}</div>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span>{{ item.nbsCodigo }} - {{ item.nbsDescricao }}</span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-autocomplete
                                v-model="objNf.classificacaoIbsCbs"
                                :items="classificacaoTributariaOptions"
                                item-text="classificacaoTributariaDescricao"
                                item-value="id"
                                label="Classificação Tributária"
                                dense
                                outlined
                                :rules="[v => !!v || 'Classificação Tributária é obrigatória']"
                                :disabled="!objNf.nbs"
                            >
                                <template v-slot:item="{ item }">
                                    <div>{{ item.classificacaoTributariaCodigo }} - {{ item.classificacaoTributariaDescricao }}</div>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span>{{ item.classificacaoTributariaCodigo }} - {{ item.classificacaoTributariaDescricao }}</span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-autocomplete
                                v-model="objNf.indicadorOperacao"
                                :items="indicadorOperacaoOptions"
                                item-text="operacaoIndicadorDescricao"
                                item-value="id"
                                label="Indicador de Operação"
                                clearable
                                dense
                                outlined
                                :rules="[v => !!v || 'Indicador de Operação é obrigatório']"
                                :disabled="!objNf.classificacaoIbsCbs"
                            >
                                <template v-slot:item="{ item }">
                                    <div>{{ item.operacaoIndicadorCodigo }} - {{ item.operacaoIndicadorDescricao }}</div>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span>{{ item.operacaoIndicadorCodigo }} - {{ item.operacaoIndicadorDescricao }}</span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-autocomplete
                                v-model="objNf.tributacaoMunicipal"
                                :items="tributacaoMunicipalOptions"
                                item-text="naturezaOperacao"
                                item-value="id"
                                label="Tributação Municipal"
                                dense
                                outlined
                                return-object
                                @change="selectedTributacao"
                                :disabled="!objNf.enquadramento"
                            >
                                <template v-slot:item="{ item }">
                                    <div class="d-flex flex-column">
                                        <div class="font-weight-bold">{{ item.codigo }}</div>
                                        <div>{{ item.naturezaOperacao }}</div>
                                    </div>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-autocomplete
                                v-model="objNf.regimeTributario"
                                :items="regimeTributarioList"
                                item-text="descricao"
                                item-value="id"
                                label="Regime Tributario"
                                dense
                                outlined
                                :disabled="!objNf.enquadramento"
                            >
                                <template v-slot:item="{ item }">
                                    <div class="d-flex flex-column">
                                        <div class="font-weight-bold">{{ item.codigo }}</div>
                                        <div>{{ item.descricao }}</div>
                                    </div>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="12" lg="12">
                            <v-text-field v-model="objNf.tipoServico" clearable outlined label="Tipo de Serviço" />
                        </v-col>

                        <!-- <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.codMunicipio" clearable outlined label="Código do serviço no município" />
                        </v-col> -->

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.pis" v-money="money" outlined readonly label="PIS" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.confins" v-money="money" outlined readonly label="COFINS" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.csll" v-money="money" outlined readonly label="CSLL" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.ir" v-money="money" outlined readonly label="IR" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.inss" v-money="money" outlined readonly label="INSS" />
                        </v-col>

                        <!-- <v-col cols="12" md="6" lg="3">
                            <v-text-field v-model="objNf.iss" v-money="money" clearable outlined label="ISS" @blur="calcImpostos" />
                        </v-col> -->

                        <v-col cols="12" md="6" lg="3">
                            <v-text-field v-model="objNf.liquidos" :key="updtaeSum" v-money="money" clearable outlined label="Valor Líquido" :readonly="true" />
                        </v-col>
<!--
                        <v-col cols="12" md="6" lg="3">
                            <v-text-field v-model="objNf.dataEmit" type="date" clearable outlined label="Data de Emissão" :readonly="true" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                            <v-text-field v-model="objNf.dateVenc" type="date" clearable outlined label="Data de Vencimento" />
                        </v-col> --->
                        <v-col cols="12" md="12" lg="12">
                            <v-textarea v-model="objNf.descricao" clearable outlined label="Descrição detalhada do serviço prestado" />
                        </v-col>
                    </v-row>
                </v-card-title>

            </v-card>

            <v-card class="mb-5 mt-5">
                <v-card-title>
                    IBS/CBS
                </v-card-title>

                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="4">
                            <v-switch
                                v-model="objNf.informarIbsCbs"
                                inset
                                label="Informar NBS / IBSCBS"
                            />
                        </v-col>
                    </v-row>

                    <template v-if="objNf.informarIbsCbs">
                        <v-row dense>
                            <v-col cols="12" sm="6" md="6">
                                <v-autocomplete
                                    v-model="objNf.cstIbsCbs"
                                    :items="notaFiscalItemCST"
                                    item-text="descricao"
                                    item-value="id"
                                    label="CST"
                                    dense
                                    outlined
                                >
                                    <template v-slot:item="{ item }">
                                        <div>{{ item.codigo }} - {{ item.descricao }}</div>
                                    </template>
                                    <template v-slot:selection="{ item }">
                                        <span>{{ item.codigo }} - {{ item.descricao }}</span>
                                    </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6" md="3">
                                <v-text-field
                                    v-model="objNf.valorBaseCalculoIbsCbs"
                                    v-money="money"
                                    outlined
                                    readonly
                                    label="Valor da Base de Cálculo"
                                />
                            </v-col>
                        </v-row>

                        <v-simple-table class="mt-4">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Tributo</th>
                                        <th class="text-left">Alíquota</th>
                                        <th class="text-left">Redução</th>
                                        <th class="text-left">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>CBS</td>
                                        <td>
                                            <v-text-field
                                                v-model="objNf.aliquotaCbs"
                                                dense
                                                hide-details
                                                outlined
                                            />
                                        </td>
                                        <td>
                                            <v-text-field
                                                v-model="objNf.reducaoCbs"
                                                dense
                                                hide-details
                                                outlined
                                            />
                                        </td>
                                        <td>{{ formatCurrencyFromCents(objNf.valorCbs) }}</td>
                                    </tr>
                                    <tr>
                                        <td>IBS Estadual</td>
                                        <td>
                                            <v-text-field
                                                v-model="objNf.aliquotaIbsEstadual"
                                                dense
                                                hide-details
                                                outlined
                                            />
                                        </td>
                                        <td>
                                            <v-text-field
                                                v-model="objNf.reducaoIbsEstadual"
                                                dense
                                                hide-details
                                                outlined
                                            />
                                        </td>
                                        <td>{{ formatCurrencyFromCents(objNf.valorIbsEstadual) }}</td>
                                    </tr>
                                    <tr>
                                        <td>IBS Municipal</td>
                                        <td>
                                            <v-text-field
                                                v-model="objNf.aliquotaIbsMunicipal"
                                                dense
                                                hide-details
                                                outlined
                                            />
                                        </td>
                                        <td>
                                            <v-text-field
                                                v-model="objNf.reducaoIbsMunicipal"
                                                dense
                                                hide-details
                                                outlined
                                            />
                                        </td>
                                        <td>{{ formatCurrencyFromCents(objNf.valorIbsMunicipal) }}</td>
                                    </tr>
                                    <tr>
                                        <td>Total</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>{{ formatCurrencyFromCents(objNf.totalIbsCbs) }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </template>
                </v-card-text>
            </v-card>

    </v-form>
</template>

<script>
import {VMoney} from 'v-money'
import Vue from 'vue';
export default {
    name: 'NotaFiscalServico',
    directives: { money: VMoney },
    props: ['projects', 'userInfo', 'item', 'isOpen', 'valorNf', 'clientes', 'clienteSelected', 'pacelasCads'],
    data(){
        return {
            openExpansionJobOs: false,
            salesOrders: [],
            syncingFromParent: false,
            isCalculatingImpostos: false,
            fiscalCatalogsLoaded: false,
            componentKey: 0,
            totalNf: 0,
            formValido: false,
            updtaeSum: 0,
            lastSelectedClienteId: null,
            loadingJobItens: false,
            lastLoadedJobItensId: null,
            localStateUfCache: {},
            localCityDescricaoCache: {},
            localCityCodigoCache: {},
            money: {
                locale: "pt-br",
                decimal: '.',
                thousands: '.',
                prefix: '',
                precision: 2,
                masked: false
            },
            parcelas: this.pacelasCads.length > 0 ?  this.pacelasCads : [
                { numParcela: '01', vencimento: null, vrlParcela: 0 }
            ],
            aliquoataOptions: [
                { text: '2%', value: 2 },
                { text: '3%', value: 3 },
                { text: '4%', value: 4 },
                { text: '5%', value: 5 }
            ],
            headers: [
                { text: 'Descrição', value: 'descricao' },
                { text: 'Tipo', value: 'tipo' },
                { text: 'Quantidade', value: 'quantidade' },
                { text: 'Preço Unitario', value: 'precoUnitario' },
                { text: 'Preço Total', value: 'precoTotal' }
            ],
            dataItensJob: [],
            regimeTributarioList: [],
            enquadramentoList: [],
            nbsList: [],
            tributacaoList: [],
            cnaeList: [],
            notaFiscalItemCST: [],
            notaFiscalItemClassificacao: [],
            nbsCadastroList: [],
            cestCadastroList: [],
            indicadorOperacaoCadastroList: [],
            classificacaoTributariaCadastroList: [],
            tipoEquipamentoList: [],
            tributacaoMunicipalOptions: [],
            regimeTributarioOptions: [],
            nbsOptions: [],
            cestOptions: [],
            indicadorOperacaoOptions: [],
            classificacaoTributariaOptions: [],
            objNf: {
                baseCalculo: null,
                id: null,
                cpfOrCnpjEmitente: null,
                razaoSocialNomeEmitente: null,
                cpfOrCnpjTomador: null,
                razaoSocialNomeTomador: null,
                cnae: null,
                inscricaoMinucipal: '',
                inscricaoMinucipalTomador: '',
                endereco: null,
                codigoCidade: '',
                localEmissao: null,
                emitenteLogradouro: null,
                emitenteBairro: null,
                emitenteCodCidade: null,
                localRecebimento: null,
                tipoServico: '',
                descricao: '',
                enqServico: 'Lucro Real',
                codMunicipio: '',
                job: null,
                os: null,
                dataEmit: null,
                dateVenc: null,
                valorNota: null,
                pis: 0,
                confins: 0,
                csll: 0,
                ir: 0,
                inss: 0,
                iss: 0,
                aliIss: 0,
                valueIss: 0,
                tributos: null,
                liquidos: 0,
                tomadorUf: null,
                tomadorNumero: null,
                tomadorCep: null,
                tomadorEmail: null,
                jobItens: [],
                regimeTributario: null,
                tributacaoMunicipal: null,
                aliquota: null,
                imposto: null,
                dedutivel: null,
                informarIbsCbs: true,
                cstIbsCbs: undefined,
                classificacaoIbsCbs: undefined,
                nbs: undefined,
                cest: undefined,
                indicadorOperacao: undefined,
                valorBaseCalculoIbsCbs: 0,
                aliquotaCbs: 0.9,
                aliquotaIbsEstadual: 0.1,
                aliquotaIbsMunicipal: 0,
                reducaoCbs: 0,
                reducaoIbsEstadual: 0,
                reducaoIbsMunicipal: 0,
                valorCbs: 0,
                valorIbsEstadual: 0,
                valorIbsMunicipal: 0,
                totalIbsCbs: 0
            }
        }
    },
    methods: {
        normalizeIdArray(value) {
            const values = Array.isArray(value) ? value : (value == null ? [] : [value])

            return [...new Set(values.map((entry) => {
                if (entry == null) return null
                if (typeof entry === 'object') return entry?.id || entry?._id || null
                return String(entry).trim()
            }).filter(Boolean))]
        },

        getEnquadramentoById(enquadramentoId) {
            const id = this.resolveEntityId(enquadramentoId)
            if (!id) return null
            return this.enquadramentoList.find((item = {}) => this.resolveEntityId(item?.id || item?._id) === id) || null
        },

        resolveDependentOptionsFromEnquadramento(enquadramento = {}) {
            const nbsIds = this.normalizeIdArray(enquadramento?.nbss)
            const cstRefs = this.normalizeIdArray(
                enquadramento?.csts ||
                enquadramento?.cests ||
                enquadramento?.cest ||
                enquadramento?.cestes ||
                enquadramento?.cestServico ||
                enquadramento?.cestServicos
            ).map((value) => String(value).trim())
            const indicadorIds = this.normalizeIdArray(enquadramento?.indicadoresDeOperacao)
            const classificacaoIds = this.normalizeIdArray(enquadramento?.classificacacoesTributaria)

            const cstRefSet = new Set(cstRefs)

            const isCstMatch = (item = {}) => {
                const itemId = this.resolveEntityId(item?.id || item?._id)
                const itemCodigo = String(item?.codigo || item?.cst || item?.cstCodigo || '').trim()

                return cstRefSet.has(String(itemId || '').trim()) || cstRefSet.has(itemCodigo)
            }

            const nbsOptions = this.nbsCadastroList.filter((item = {}) => nbsIds.includes(this.resolveEntityId(item?.id || item?._id)))
            const cestOptions = this.cestCadastroList.filter((item = {}) => isCstMatch(item))
            const indicadorOptions = this.indicadorOperacaoCadastroList.filter((item = {}) => indicadorIds.includes(this.resolveEntityId(item?.id || item?._id)))
            const classificacaoOptions = this.classificacaoTributariaCadastroList.filter((item = {}) => classificacaoIds.includes(this.resolveEntityId(item?.id || item?._id)))

            return {
                nbsOptions,
                cestOptions,
                indicadorOptions,
                classificacaoOptions
            }
        },

        applySingleOrKeepSelection(fieldName, options = []) {
            const lista = Array.isArray(options) ? options : []
            const currentId = this.resolveEntityId(this.objNf[fieldName])

            if (lista.length === 1) {
                this.objNf[fieldName] = this.resolveEntityId(lista[0]?.id || lista[0]?._id)
                return
            }

            if (!lista.length) {
                this.objNf[fieldName] = undefined
                return
            }

            const existsInList = lista.some((item = {}) => this.resolveEntityId(item?.id || item?._id) === currentId)
            if (!existsInList) {
                this.objNf[fieldName] = undefined
            }
        },

        applyRegimeAndTributacaoDefaults() {
            if (this.tributacaoMunicipalOptions.length === 1) {
                this.objNf.tributacaoMunicipal = this.tributacaoMunicipalOptions[0]
                this.selectedTributacao(this.tributacaoMunicipalOptions[0])
            } else if (this.tributacaoMunicipalOptions.length > 1) {
                const currentId = this.resolveEntityId(this.objNf.tributacaoMunicipal?.id || this.objNf.tributacaoMunicipal?._id || this.objNf.tributacaoMunicipal)
                const exists = this.tributacaoMunicipalOptions.some((item = {}) => this.resolveEntityId(item?.id || item?._id) === currentId)
                if (!exists) {
                    this.objNf.tributacaoMunicipal = null
                }
            }
        },

        clearDependentOptionsAndValues() {
            this.nbsOptions = []
            this.cestOptions = []
            this.indicadorOperacaoOptions = []
            this.classificacaoTributariaOptions = []
            this.tributacaoMunicipalOptions = []
            this.regimeTributarioOptions = []

            this.objNf.nbs = undefined
            this.objNf.cest = undefined
            this.objNf.indicadorOperacao = undefined
            this.objNf.classificacaoIbsCbs = undefined
            this.objNf.tributacaoMunicipal = null
            this.objNf.enqServico = 'Lucro Real'
        },

        applyEnquadramentoDependencies(enquadramentoId) {
            if (!this.fiscalCatalogsLoaded) return

            const enquadramento = this.getEnquadramentoById(enquadramentoId)
            if (!enquadramento) {
                this.clearDependentOptionsAndValues()
                return
            }

            const { nbsOptions, cestOptions, indicadorOptions, classificacaoOptions } = this.resolveDependentOptionsFromEnquadramento(enquadramento)

            this.nbsOptions = nbsOptions
            this.cestOptions = cestOptions
            this.indicadorOperacaoOptions = indicadorOptions
            this.classificacaoTributariaOptions = classificacaoOptions

            this.tributacaoMunicipalOptions = [...this.tributacaoList]
            this.regimeTributarioOptions = this.regimeTributarioList
                .map((item = {}) => item?.descricao)
                .filter((descricao) => !!String(descricao || '').trim())

            this.applySingleOrKeepSelection('nbs', this.nbsOptions)
            this.applySingleOrKeepSelection('cest', this.cestOptions)
            this.applySingleOrKeepSelection('indicadorOperacao', this.indicadorOperacaoOptions)
            this.applySingleOrKeepSelection('classificacaoIbsCbs', this.classificacaoTributariaOptions)
            this.applyRegimeAndTributacaoDefaults()
        },

        onEnquadramentoChange(value) {
            this.applyEnquadramentoDependencies(value)
        },

        resolveEntityId(value) {
            if (value == null) return null

            if (typeof value === 'object') {
                return value?.id || value?._id || null
            }

            const normalized = String(value).trim()
            if (!normalized || normalized === '[object Object]') return null

            return normalized
        },

        resolveDisplayValueFromObject(value, preferredKeys = []) {
            if (!value || typeof value !== 'object') return ''
            for (const key of preferredKeys) {
                const selected = this.firstNonEmpty(value?.[key])
                if (selected) return String(selected).trim()
            }

            return ''
        },

        normalizeComparison(value) {
            return String(value || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[_-]+/g, ' ')
                .replace(/\s+/g, ' ')
                .trim()
                .toUpperCase()
        },

        isServicoJobItem(item = {}) {
            const tipoId = this.resolveEntityId(item?.tipoDeEquipamento)
            const tipoCadastro = this.tipoEquipamentoList.find((tipo = {}) => this.resolveEntityId(tipo?.id || tipo?._id) === tipoId)
            const descricao = item?.tipoDeEquipamentoDescricao
                || item?.tipoDeEquipamento?.descricao
                || item?.tipoDeEquipamento?.nome
                || tipoCadastro?.descricao
                || tipoCadastro?.nome
                || tipoCadastro?.codigo

            return this.normalizeComparison(descricao) === 'SERVICOS'
        },

        firstNonEmpty(...values) {
            for (const value of values) {
                if (value === null || value === undefined) continue
                const text = String(value).trim()
                if (text) return value
            }
            return ''
        },

        normalizeKey(value) {
            return String(value || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-zA-Z0-9]/g, '')
                .toLowerCase()
        },

        pickFirstByNormalizedKeys(source = {}, normalizedKeys = []) {
            if (!source || typeof source !== 'object') return ''
            const allowedKeys = new Set((normalizedKeys || []).map((key) => this.normalizeKey(key)))

            for (const [key, value] of Object.entries(source)) {
                if (!allowedKeys.has(this.normalizeKey(key))) continue
                const selected = this.firstNonEmpty(value)
                if (selected) return selected
            }

            return ''
        },

        async buildTomadorEndereco(cliente = {}) {
            const enderecoFaturamento = this.firstNonEmpty(
                cliente?.faturamentoEndereco,
                cliente?.cobrancaEndereco
            )

            const ufBase = this.firstNonEmpty(
                cliente?.faturamentoEstado,
                cliente?.faturamentoEstadoNome,
                cliente?.cobrancaEstado,
                cliente?.cobrancaEstadoNome,
                cliente?.cobrancaUF,
                cliente?.uf,
                cliente?.estado
            )
            const cidadeBase = this.firstNonEmpty(
                cliente?.faturamentoCidade,
                cliente?.faturamentoCidadeNome,
                cliente?.cobrancaCidade,
                cliente?.cobrancaCidadeNome,
                cliente?.cidade,
                cliente?.descricaoCidade
            )
            const uf = await this.resolveUfSigla(ufBase)
            const cidade = await this.resolveCidadeDescricao(cidadeBase)
            const logradouro = this.firstNonEmpty(
                cliente?.faturamentoEndereco,
                cliente?.cobrancaEndereco,
                cliente?.logradouro,
                cliente?.endereco,
                cliente?.cobrancaLogradouro
            )
            const numero = this.firstNonEmpty(cliente?.faturamentoNumero, cliente?.cobrancaNumero, cliente?.numero)
            const bairro = this.firstNonEmpty(cliente?.faturamentoBairro, cliente?.cobrancaBairro, cliente?.bairro)

            const enderecoCompleto = this.firstNonEmpty(cliente?.enderecoCompleto)
            const enderecoCompletoNormalizado = String(enderecoCompleto || '').trim()
            const enderecoCompletoTemUuid = this.isLikelyUuid(enderecoCompletoNormalizado)

            return this.firstNonEmpty(
                enderecoFaturamento,
                !enderecoCompletoTemUuid ? enderecoCompleto : '',
                [logradouro, numero, bairro, cidade, uf].filter(Boolean).join(' - ')
            )
        },

        getClienteEmailXml(cliente = {}) {
            const contato = Array.isArray(cliente?.contatos) ? (cliente.contatos[0] || {}) : {}

            const emailByNormalizedKey = this.firstNonEmpty(
                this.pickFirstByNormalizedKeys(cliente, [
                    'emailXml',
                    'emailXML',
                    'emailNF',
                    'emailNotaFiscal',
                    'clienteEmailXml',
                    'clienteEmailXML',
                    'clienteEmailNF',
                    'clienteEmailNotaFiscal'
                ]),
                this.pickFirstByNormalizedKeys(contato, [
                    'emailXml',
                    'emailXML',
                    'emailNF',
                    'emailNotaFiscal'
                ])
            )

            return this.firstNonEmpty(
                emailByNormalizedKey,
                cliente?.emailXml,
                cliente?.emailXML,
                cliente?.email_xml,
                cliente?.emailNf,
                cliente?.emailNotaFiscal,
                cliente?.email,
                contato?.emailXml,
                contato?.emailXML,
                contato?.email
            )
        },

        getJobClienteEmailXml(job = {}) {
            const contato = Array.isArray(job?.cliente?.contatos) ? (job.cliente.contatos[0] || {}) : {}
            const emailByNormalizedKey = this.firstNonEmpty(
                this.pickFirstByNormalizedKeys(job, [
                    'clienteEmailXml',
                    'clienteEmailXML',
                    'clienteEmailNF',
                    'clienteEmailNotaFiscal',
                    'emailXml',
                    'emailXML',
                    'emailNF',
                    'emailNotaFiscal'
                ]),
                this.pickFirstByNormalizedKeys(job?.cliente || {}, [
                    'clienteEmailXml',
                    'clienteEmailXML',
                    'clienteEmailNF',
                    'clienteEmailNotaFiscal',
                    'emailXml',
                    'emailXML',
                    'emailNF',
                    'emailNotaFiscal'
                ]),
                this.pickFirstByNormalizedKeys(contato, [
                    'emailXml',
                    'emailXML',
                    'emailNF',
                    'emailNotaFiscal'
                ])
            )

            return this.firstNonEmpty(
                emailByNormalizedKey,
                job?.email,
                job?.clienteEmail,
                job?.cliente_email,
                job?.clienteEmailXml,
                job?.clienteEmailXML,
                job?.cliente_email_xml,
                job?.emailXml,
                job?.emailXML,
                job?.email_xml,
                job?.cliente?.emailNf,
                job?.cliente?.emailNotaFiscal,
                job?.cliente?.emailXml,
                job?.cliente?.emailXML,
                job?.cliente?.email
            )
        },

        getJobUf(job = {}) {
            return this.firstNonEmpty(
                this.resolveDisplayValueFromObject(job?.estado, ['sigla', 'uf', 'abbreviation', 'codigo', 'descricao', 'nome']),
                this.resolveDisplayValueFromObject(job?.uf, ['sigla', 'uf', 'abbreviation', 'codigo', 'descricao', 'nome']),
                job?.uf,
                job?.estado,
                job?.clienteUf,
                job?.clienteEstado,
                job?.cliente?.faturamentoEstado,
                job?.cliente?.faturamentoEstadoNome,
                job?.cliente?.uf,
                job?.cliente?.estado,
                job?.cliente?.cobrancaUF,
                job?.cliente?.cobrancaEstado
            )
        },

        isLikelyUuid(value) {
            const normalized = String(value || '').trim()
            return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/.test(normalized)
        },

        async resolveUfSigla(value) {
            const objectDisplay = this.resolveDisplayValueFromObject(value, ['sigla', 'uf', 'abbreviation', 'codigo', 'descricao', 'nome'])
            const rawId = this.resolveEntityId(value)
            const raw = this.firstNonEmpty(objectDisplay, rawId, value)
            const normalized = String(raw || '').trim()
            if (!normalized || normalized === '[object Object]') return ''

            if (this.localStateUfCache[normalized]) {
                return this.localStateUfCache[normalized]
            }

            if (!this.isLikelyUuid(normalized)) {
                if (normalized.length === 2) {
                    const ufSigla = normalized.toUpperCase()
                    this.localStateUfCache = {
                        ...this.localStateUfCache,
                        [normalized]: ufSigla
                    }
                    return ufSigla
                }

                const searchFields = ['nome', 'descricao', 'codigo', 'sigla']
                for (const field of searchFields) {
                    try {
                        const response = await Vue.prototype.$http.get('/Entity/LocalState/search-fields', {
                            params: {
                                page: 1,
                                limit: 1,
                                searchFields: field,
                                value: normalized,
                                mode: 'Equals'
                            }
                        })

                        const state = this.extractEntityPayload(response) || {}
                        const uf = this.firstNonEmpty(state?.codigo, state?.sigla, state?.uf, state?.abbreviation)
                        if (uf) {
                            const ufSigla = String(uf).trim().toUpperCase()
                            this.localStateUfCache = {
                                ...this.localStateUfCache,
                                [normalized]: ufSigla
                            }
                            return ufSigla
                        }
                    } catch (error) {
                        // Keep fallback behavior below.
                    }
                }

                return normalized
            }

            try {
                const response = await Vue.prototype.$http.get(`/Entity/LocalState/${normalized}`)
                const state = this.extractEntityPayload(response) || {}
                const uf = this.firstNonEmpty(state?.codigo, state?.sigla, state?.uf, state?.abbreviation)

                if (uf) {
                    this.localStateUfCache = {
                        ...this.localStateUfCache,
                        [normalized]: String(uf).trim().toUpperCase()
                    }
                }

                return String(uf || '').trim().toUpperCase()
            } catch (error) {
                return ''
            }
        },

        async resolveCidadeDescricao(value) {
            const objectDisplay = this.resolveDisplayValueFromObject(value, ['descricao', 'nome', 'cidade', 'codigo'])
            const rawId = this.resolveEntityId(value)
            const raw = this.firstNonEmpty(objectDisplay, rawId, value)
            const normalized = String(raw || '').trim()
            if (!normalized || normalized === '[object Object]') return ''

            if (!this.isLikelyUuid(normalized)) {
                return normalized
            }

            if (this.localCityDescricaoCache[normalized]) {
                return this.localCityDescricaoCache[normalized]
            }

            try {
                const response = await Vue.prototype.$http.get(`/Entity/LocalCity/${normalized}`)
                let city = response?.data?.data?.data || response?.data?.data || response?.data || {}
                if (Array.isArray(city)) {
                    city = city[0] || {}
                }
                const descricao = this.firstNonEmpty(city?.descricao, city?.nome, city?.cidade, city?.codigo)

                if (descricao) {
                    this.localCityDescricaoCache = {
                        ...this.localCityDescricaoCache,
                        [normalized]: String(descricao).trim()
                    }
                }

                return String(descricao || '').trim()
            } catch (error) {
                return ''
            }
        },

        extractEntityPayload(response) {
            const payload = response?.data?.data?.data ?? response?.data?.data ?? response?.data ?? null
            if (Array.isArray(payload)) {
                return payload[0] || null
            }
            return payload
        },

        async resolveCidadeCodigo(value) {
            const objectCode = this.resolveDisplayValueFromObject(value, ['code', 'codigo', 'codigoIbge'])
            const rawId = this.resolveEntityId(value)
            const raw = this.firstNonEmpty(objectCode, rawId, value)
            const normalized = String(raw || '').trim()
            if (!normalized || normalized === '[object Object]') return ''

            // If it is already a numeric city code, keep as-is.
            if (!this.isLikelyUuid(normalized) && /^\d+$/.test(normalized)) {
                return normalized
            }

            if (this.localCityCodigoCache[normalized]) {
                return this.localCityCodigoCache[normalized]
            }

            const registerResolvedCode = (cacheKey, city = {}) => {
                const code = this.firstNonEmpty(city?.code, city?.codigo, city?.codigoIbge)
                if (!code) return ''

                const normalizedCode = String(code).trim()
                this.localCityCodigoCache = {
                    ...this.localCityCodigoCache,
                    [cacheKey]: normalizedCode
                }

                const cityId = this.resolveEntityId(city?.id || city?._id)
                if (cityId) {
                    this.localCityCodigoCache[cityId] = normalizedCode
                }

                return normalizedCode
            }

            try {
                if (this.isLikelyUuid(normalized)) {
                    const response = await Vue.prototype.$http.get(`/Entity/LocalCity/${normalized}`)
                    const city = this.extractEntityPayload(response) || {}
                    return registerResolvedCode(normalized, city)
                }

                const searchFields = ['nome', 'descricao', 'cidade']
                for (const field of searchFields) {
                    const response = await Vue.prototype.$http.get('/Entity/LocalCity/search-fields', {
                        params: {
                            page: 1,
                            limit: 1,
                            searchFields: field,
                            value: normalized,
                            mode: 'Equals'
                        }
                    })

                    const city = this.extractEntityPayload(response) || {}
                    const code = registerResolvedCode(normalized, city)
                    if (code) return code
                }
            } catch (error) {
                return ''
            }

            return ''
        },

        clearTomador() {
            this.objNf.destinatario = null
            this.objNf.cpfOrCnpjTomador = null
            this.objNf.razaoSocialNomeTomador = null
            this.objNf.inscricaoMinucipalTomador = ''
            this.objNf.endereco = null
            this.objNf.codigoCidade = ''
            this.objNf.tomadorUf = null
            this.objNf.tomadorNumero = null
            this.objNf.tomadorComplemento = null
            this.objNf.tomadorCep = null
            this.objNf.tomadorEmail = null
            this.objNf.localRecebimento = null
        },

        async fillTomadorFromJob(job = {}) {
            const clienteId = this.resolveEntityId(job?.cliente)
            if (!clienteId) {
                this.clearTomador()
                return
            }

            let cliente = this.clientes.find((item = {}) => this.resolveEntityId(item?.id || item?._id) === clienteId)
            if (!cliente) {
                const response = await Vue.prototype.$http.get(`/Entity/Cliente/${clienteId}`)
                cliente = response?.data?.data
            } else {
                try {
                    const response = await Vue.prototype.$http.get(`/Entity/Cliente/${clienteId}`)
                    cliente = {
                        ...(cliente || {}),
                        ...(response?.data?.data || {})
                    }
                } catch (error) {
                    // Keep using in-memory cliente when detail lookup fails.
                }
            }
            if (!cliente) return

            this.objNf.destinatario = cliente
            this.objNf.cpfOrCnpjTomador = cliente?.cnpj || cliente?.cpfCnpj || cliente?.documento || ''
            this.objNf.razaoSocialNomeTomador = cliente?.razaoSocial || cliente?.nomeFantasia || cliente?.nome || ''
            this.objNf.inscricaoMinucipalTomador = cliente?.inscricaoMunicipal || cliente?.im || ''

            const tomadorCidadeFaturamentoId = this.firstNonEmpty(
                cliente?.faturamentoCidade,
                job?.cliente?.faturamentoCidade
            )
            const tomadorCodigoCidadeBase = this.firstNonEmpty(
                cliente?.faturamentoCidadeCodigo,
                cliente?.faturamentoCodigoCidade,
                await this.resolveCidadeCodigo(tomadorCidadeFaturamentoId),
                cliente?.codigoCidade,
                cliente?.codigoIbgeCidade,
                cliente?.cidadeCodigoIbge,
                cliente?.cobrancaCodigoCidade,
                cliente?.codigoCidadeCobranca,
                job?.cliente?.faturamentoCidadeCodigo,
                job?.cliente?.faturamentoCodigoCidade
            )
            const tomadorCidadeRelationBase = this.firstNonEmpty(
                cliente?.faturamentoCidade,
                cliente?.faturamentoCidadeNome,
                cliente?.cobrancaCidade,
                cliente?.cobrancaCidadeNome,
                cliente?.cidade,
                cliente?.descricaoCidade,
                job?.cliente?.faturamentoCidade,
                job?.cliente?.faturamentoCidadeNome,
                job?.cliente?.cidade,
                job?.cliente?.cobrancaCidade
            )
            this.objNf.codigoCidade = this.firstNonEmpty(
                tomadorCodigoCidadeBase,
                await this.resolveCidadeCodigo(tomadorCidadeRelationBase)
            )

            const tomadorUfNomeFaturamento = this.firstNonEmpty(
                cliente?.faturamentoEstadoNome,
                job?.cliente?.faturamentoEstadoNome
            )
            const tomadorUfBase = this.firstNonEmpty(
                tomadorUfNomeFaturamento,
                cliente?.faturamentoEstado,
                cliente?.faturamentoEstadoNome,
                cliente?.uf,
                cliente?.estado,
                cliente?.cobrancaEstado,
                cliente?.cobrancaUF,
                this.getJobUf(job)
            )
            const tomadorUfResolvido = await this.resolveUfSigla(tomadorUfBase)
            this.objNf.tomadorUf = this.firstNonEmpty(
                tomadorUfNomeFaturamento,
                tomadorUfResolvido,
                !this.isLikelyUuid(String(this.resolveEntityId(tomadorUfBase) || tomadorUfBase || '').trim()) ? this.firstNonEmpty(tomadorUfBase) : ''
            )
            this.objNf.tomadorNumero = this.firstNonEmpty(cliente?.faturamentoNumero, cliente?.cobrancaNumero, cliente?.numero)
            this.objNf.tomadorComplemento = this.firstNonEmpty(cliente?.faturamentoComplemento, cliente?.cobrancaComplemento, cliente?.complemento)
            this.objNf.tomadorCep = this.firstNonEmpty(cliente?.faturamentoCEP, cliente?.cobrancaCEP, cliente?.cobrancaCep, cliente?.cep)
            this.objNf.tomadorEmail = this.firstNonEmpty(
                this.getJobClienteEmailXml(job),
                this.getClienteEmailXml(cliente),
                this.getClienteEmailXml(job?.cliente || {})
            )
            const enderecoTomador = this.firstNonEmpty(
                cliente?.entregaEndereco,
                cliente?.entregaLogradouro,
                cliente?.faturamentoEndereco,
                cliente?.cobrancaEndereco,
                cliente?.logradouro,
                cliente?.endereco,
                cliente?.cobrancaLogradouro
            )
            this.objNf.localRecebimento = enderecoTomador
            // Endereço Completo deve refletir o mesmo valor do Local do Recebimento.
            this.objNf.endereco = enderecoTomador || await this.buildTomadorEndereco(cliente)
            this.lastSelectedClienteId = clienteId
            // Sincroniza o cliente resolvido pelo Job com o componente pai (necessário para salvar).
            this.$emit('selectedCliente', cliente)
        },

        async getDataEntity(schemaName){
            const response = await Vue.prototype.$http.get(`/Entity/${schemaName}`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            });

            return response.data.data.data
        },

        async getNotaFiscalItemCST() {
            const response = await Vue.prototype.$http.get('/Entity/NotaFiscalItemCST', {
                params: {
                    page: 1,
                    limit: 9999
                }
            });

            this.notaFiscalItemCST = response.data.data.data;
        },

        async getNotaFiscalItemClassificacao() {
            const response = await Vue.prototype.$http.get('/Entity/NotaFiscalItemClassificacaoTributaria', {
                params: {
                    page: 1,
                    limit: 9999
                }
            });

            this.notaFiscalItemClassificacao = response.data.data.data;
        },

        toIntegerMoney(value) {
            if (value == null || value === '') return 0;
            if (typeof value === 'number') return Number.isFinite(value) ? Math.round(value * 100) : 0;

            const rawValue = String(value).trim().replace(/\s/g, '');
            if (!rawValue) return 0;

            const numericValue = this.toDecimalNumber(rawValue);
            return Number.isFinite(numericValue) ? Math.round(numericValue * 100) : 0;
        },

        toDecimalNumber(value) {
            if (value == null || value === '') return 0;
            if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

            const rawValue = String(value).trim().replace(/\s/g, '');
            if (!rawValue) return 0;

            const sanitizedValue = rawValue.replace(/[^\d,.-]/g, '');
            const lastCommaIndex = sanitizedValue.lastIndexOf(',');
            const lastDotIndex = sanitizedValue.lastIndexOf('.');

            let normalizedValue = sanitizedValue;

            if (lastCommaIndex > -1 && lastDotIndex > -1) {
                if (lastCommaIndex > lastDotIndex) {
                    normalizedValue = sanitizedValue.replace(/\./g, '').replace(',', '.');
                } else {
                    normalizedValue = sanitizedValue.replace(/,/g, '');
                }
            } else if (lastCommaIndex > -1) {
                normalizedValue = sanitizedValue.replace(/\./g, '').replace(',', '.');
            } else {
                const dotMatches = sanitizedValue.match(/\./g) || [];
                if (dotMatches.length > 1) {
                    const integerPart = sanitizedValue.slice(0, lastDotIndex).replace(/\./g, '');
                    const decimalPart = sanitizedValue.slice(lastDotIndex + 1);
                    normalizedValue = `${integerPart}.${decimalPart}`;
                }
            }

            const numericValue = Number(normalizedValue);
            return Number.isFinite(numericValue) ? numericValue : 0;
        },

        normalizeAliquotaToDecimal(value) {
            const normalizedValue = (value && typeof value === 'object')
                ? this.firstNonEmpty(value?.value, value?.codigo, value?.text, value?.descricao)
                : value;

            const numericValue = this.toDecimalNumber(normalizedValue);
            if (!Number.isFinite(numericValue) || numericValue === 0) return 0;
            return numericValue > 1 ? numericValue / 100 : numericValue;
        },

        parseAliquotaDecimal(value) {
            return this.normalizeAliquotaToDecimal(value);
        },

        onAliquotaChange(value) {
            this.objNf.aliquota = value;
            this.$nextTick(() => {
                this.calcImpostos();
            });
        },

        formatMoneyMasked(cents) {
            const numericCents = Number(cents) || 0;
            return (numericCents / 100).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        formatCurrencyFromCents(value) {
            return Number((this.toIntegerMoney(value) || 0) / 100).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        },

        formatCurrencyFromNumber(value) {
            const numericValue = Number(value || 0);
            return Number.isFinite(numericValue)
                ? numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                : Number(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },

        formatPercentualIbsCbs(value) {
            return `${Number(value || 0).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}%`;
        },

        parsePercentualIbsCbs(value) {
            if (value == null || value === '') return 0;
            if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

            const normalized = String(value)
                .trim()
                .replace(/\./g, '')
                .replace(',', '.');

            return Number(normalized) || 0;
        },

        limparIbsCbsServico() {
            this.objNf.valorBaseCalculoIbsCbs = 0;
            this.objNf.valorCbs = 0;
            this.objNf.valorIbsEstadual = 0;
            this.objNf.valorIbsMunicipal = 0;
            this.objNf.totalIbsCbs = 0;
        },

        calcularIbsCbsServico() {
            if (!this.objNf.informarIbsCbs) {
                this.limparIbsCbsServico();
                return;
            }

            const base = this.toIntegerMoney(this.objNf.baseCalculo || this.objNf.valorNf || (Number(this.valorNf) * 100));
            const aliquotaCbs = this.parseAliquotaDecimal(this.objNf.aliquotaCbs) * 100;
            const aliquotaIbsEstadual = this.parseAliquotaDecimal(this.objNf.aliquotaIbsEstadual) * 100;
            const aliquotaIbsMunicipal = this.parseAliquotaDecimal(this.objNf.aliquotaIbsMunicipal) * 100;
            const reducaoCbs = this.parsePercentualIbsCbs(this.objNf.reducaoCbs);
            const reducaoIbsEstadual = this.parsePercentualIbsCbs(this.objNf.reducaoIbsEstadual);
            const reducaoIbsMunicipal = this.parsePercentualIbsCbs(this.objNf.reducaoIbsMunicipal);

            const baseCbs = base * Math.max(0, 1 - (reducaoCbs / 100));
            const baseIbsEstadual = base * Math.max(0, 1 - (reducaoIbsEstadual / 100));
            const baseIbsMunicipal = base * Math.max(0, 1 - (reducaoIbsMunicipal / 100));

            this.objNf.valorBaseCalculoIbsCbs = base;
            this.objNf.valorCbs = Math.round(baseCbs * (aliquotaCbs / 100));
            this.objNf.valorIbsEstadual = Math.round(baseIbsEstadual * (aliquotaIbsEstadual / 100));
            this.objNf.valorIbsMunicipal = Math.round(baseIbsMunicipal * (aliquotaIbsMunicipal / 100));
            this.objNf.totalIbsCbs = this.objNf.valorCbs + this.objNf.valorIbsEstadual + this.objNf.valorIbsMunicipal;
        },

        async selectedJob(job){
            let jobEntity = job
            const jobId = this.resolveEntityId(job)

            if (this.loadingJobItens) {
                return
            }

            if (!jobEntity) {
                this.dataItensJob = []
                this.objNf.jobItens = []
                this.lastLoadedJobItensId = null
                this.clearTomador()
                return
            }

            if (jobId && String(jobId) === String(this.lastLoadedJobItensId) && this.dataItensJob.length > 0) {
                if (typeof jobEntity === 'object') {
                    await this.fillTomadorFromJob(jobEntity)
                }
                return
            }

            if (typeof jobEntity !== 'object') {
                if (!jobId) {
                    this.dataItensJob = []
                    this.lastLoadedJobItensId = null
                    return
                }

                const responseJob = await Vue.prototype.$http.get(`/Entity/Project/${jobId}`)
                jobEntity = responseJob?.data?.data
            }

            const resolvedJobId = this.resolveEntityId(jobEntity)
            if (!resolvedJobId) {
                this.dataItensJob = []
                this.lastLoadedJobItensId = null
                return
            }

            this.loadingJobItens = true
            this.lastLoadedJobItensId = resolvedJobId

            try {
                const responseJob = await Vue.prototype.$http.get(`/Entity/Project/${resolvedJobId}`)
                jobEntity = responseJob?.data?.data || jobEntity || {}

                const jobItensIds = Array.isArray(jobEntity?.jobItens)
                    ? jobEntity.jobItens.filter(Boolean)
                    : []

                if (jobItensIds.length === 0) {
                    this.dataItensJob = []
                    await this.fillTomadorFromJob(jobEntity)
                    return
                }

                const response = await Vue.prototype.$http.get(`/Entity/ProjectItens`, {
                    params: {
                        ids: jobItensIds.join(',')
                    }
                })

                this.dataItensJob = response?.data?.data?.data || []
                await this.fillTomadorFromJob(jobEntity)
            } finally {
                this.loadingJobItens = false
            }
        },

        selectedTributacao(tributacao){
            if (!tributacao || typeof tributacao !== 'object') return
            this.updtaeSum += 1
            this.calcImpostos()
        },

        onSelectedClienteChange(cliente) {
            if (!cliente?.id) return
            if (this.lastSelectedClienteId === cliente.id) return

            this.lastSelectedClienteId = cliente.id
            this.$emit('selectedCliente', cliente)
        },

        async getEmitente(){
            const filial = localStorage.getItem('CompanySiteIdSelected')
            if (!filial) {
                this.$notfy?.warning('Filial não selecionada. Selecione a empresa para continuar.')
                return
            }

            try {
                const response = await Vue.prototype.$http.get(`/Entity/CompanySite/${filial}`);
                this.objNf.cpfOrCnpjEmitente = response?.data?.data?.cnpj || ''

                const companySite = response?.data?.data || {}
                this.objNf.emitenteCodCidade =
                    companySite?.codigoCidade ||
                    companySite?.codCidade ||
                    companySite?.codigoIbgeCidade ||
                    companySite?.cidadeCodigoIbge ||
                    this.objNf.emitenteCodCidade

                await this.getCnpjInfo(response?.data?.data?.cnpj, 'Emitente')
            } catch (error) {
                console.error('[NF Serviço] Falha ao carregar dados do emitente:', error)
                this.$notfy?.error('Não foi possível carregar os dados do emitente.')
            }
        },

        async getCnpjInfo(value, tipo){
            if(value?.length == 18){
                let response
                try {
                    response = await Vue.prototype.$http.post('/Action/run', 
                        { 
                            actionId: "128f5633-f624-41f8-abcf-043bc39a4bb7",
                            actionName: "Action info CNPJ",
                            params: { 
                                cnpj: value.replace(/\D/g, '')
                            } 
                        })
                } catch (error) {
                    console.error('[NF Serviço] Falha ao consultar Action info CNPJ:', error)
                    this.$notfy?.error('Não foi possível consultar os dados do CNPJ.')
                    return
                }



                if(response.data.data.data?.status == "ERROR" && tipo == 'Emitente'){
                    this.$notfy.error("CNPJ invalido.");
                    this.objNf.cpfOrCnpjEmitente = ''
                    return
                }

                if(response.data.data.data?.status == "ERROR" && tipo == 'Tomador'){
                    this.$notfy.error("CNPJ invalido.");
                    this.objNf.cpfOrCnpjTomador = ''
                    return
                }

                const info = response?.data?.data?.data
                if (!info || typeof info !== 'object') {
                    this.$notfy?.error('Resposta inválida ao consultar os dados do CNPJ.')
                    return
                }

                if(tipo == 'Emitente'){
                    this.objNf.razaoSocialNomeEmitente = info.fantasia || info.nome
                    //this.objNf.cnae = info.atividade_principal[0].code
                    this.objNf.localEmissao = info.municipio
                    this.objNf.emitenteLogradouro = info.logradouro
                    this.objNf.emitenteBairro = info.bairro
                    const emitenteCodigoCidade = await this.resolveCidadeCodigo(this.objNf.localEmissao)
                    this.objNf.emitenteCodCidade = this.firstNonEmpty(
                        emitenteCodigoCidade,
                        this.objNf.emitenteCodCidade
                    )
                } 
                else if(tipo == 'Tomador'){
                    this.objNf.razaoSocialNomeTomador = info.fantasia || info.nome
                    this.objNf.endereco = `Cidade: ${info.municipio} - Rua: ${info.logradouro} - Bairro: ${info.bairro}` 
                    this.objNf.localRecebimento = info.logradouro + info.numero
                    this.objNf.tomadorEmail = info.email
                    this.objNf.tomadorNumero = info.numero
                    this.objNf.tomadorUf = info.uf
                    this.objNf.tomadorCep = info.cep
                }

                this.componentKey += 1
            }
        },


        sumParcelas(){
            return (this.sumParcelasInCents() / 100) || 0
        },

        sumParcelasInCents() {
            let sum = 0
            this.parcelas?.forEach((p) => {
                if (p?.vrlParcela == null || p?.vrlParcela === '') return
                sum += this.toIntegerMoney(p.vrlParcela)
            })

            return sum
        },

        addParcela(){
            this.parcelas.push({ 
                numParcela: String(this.parcelas.length + 1).padStart(2, '0'), 
                vencimento: null, 
                vrlParcela: 0 
            })  
        },

        async removeParcela(parcela){
            this.parcelas =  this.parcelas.filter((p) => p.numParcela != parcela.numParcela)

            if(parcela.id){
                //await Vue.prototype.$http.delete(`/Entity/FisPreDocEmiFin?id=${parcela.id}`)
            }

        },


        calcImpostos() {
            if (this.isCalculatingImpostos) return
            this.isCalculatingImpostos = true

            try {
                const valorNotaCents = this.toIntegerMoney(this.objNf.valorNf || this.valorNf)
                const baseInformada = this.toIntegerMoney(this.objNf.baseCalculo ?? this.objNf.valorNf ?? this.valorNf)
                const base = baseInformada > 0 ? baseInformada : valorNotaCents
                const trib = this.getEnquadramentoById(this.objNf.enquadramento) || {}
                const aliquotaIss = this.normalizeAliquotaToDecimal(this.objNf.aliquota)
                const dedutivel = this.toIntegerMoney(this.objNf.dedutivel)

                const baseEmReais = this.formatMoneyMasked(base)
                if (this.objNf.baseCalculo == null || this.objNf.baseCalculo === '' || this.toIntegerMoney(this.objNf.baseCalculo) !== base) {
                    this.objNf.baseCalculo = baseEmReais
                }

                const aliquotaPis = this.normalizeAliquotaToDecimal(trib.pis)
                const aliquotaCofins = this.normalizeAliquotaToDecimal(trib.cofins)
                const aliquotaCsll = this.normalizeAliquotaToDecimal(trib.csll)
                const aliquotaInss = this.normalizeAliquotaToDecimal(trib.inss)
                const aliquotaIr = this.normalizeAliquotaToDecimal(trib.ir)

                const pisCents = Math.round(base * aliquotaPis)
                const cofinsCents = Math.round(base * aliquotaCofins)
                const csllCents = Math.round(base * aliquotaCsll)
                const inssCents = Math.round(base * aliquotaInss)
                const irCents = Math.round(base * aliquotaIr)
                const issCents = Math.round(base * aliquotaIss)

                // Campos mascarados em string (padrão v-money) para o parser de salvamento.
                this.objNf.pis = this.formatMoneyMasked(pisCents)
                this.objNf.confins = this.formatMoneyMasked(cofinsCents)
                this.objNf.csll = this.formatMoneyMasked(csllCents)
                this.objNf.inss = this.formatMoneyMasked(inssCents)
                this.objNf.ir = this.formatMoneyMasked(irCents)
                this.objNf.iss = this.formatMoneyMasked(issCents)
                this.objNf.imposto = this.objNf.iss

                // Regra da tela: Valor Liquido = Valor da Nota - Imposto - Dedutivel.
                this.objNf.liquidos = this.formatMoneyMasked(Math.max(valorNotaCents - issCents - dedutivel, 0))
                this.calcularIbsCbsServico()

                this.componentKey += 1
            } finally {
                this.$nextTick(() => {
                    this.isCalculatingImpostos = false
                })
            }
        }




    },
    watch: {

        item: {
            async handler(value){
                // console.log('ITEM HANDLER ', value)
                this.syncingFromParent = true

                this.objNf = {
                    ...this.objNf,
                    ...value,
                    informarIbsCbs: value?.informarIbsCbs ?? true,
                    indicadorOperacao: value?.indicadorOperacao ?? undefined,
                    aliquotaCbs: value?.aliquotaCbs ?? 0.9,
                    aliquotaIbsEstadual: value?.aliquotaIbsEstadual ?? 0.1,
                    aliquotaIbsMunicipal: value?.aliquotaIbsMunicipal ?? 0,
                    reducaoCbs: value?.reducaoCbs ?? 0,
                    reducaoIbsEstadual: value?.reducaoIbsEstadual ?? 0,
                    reducaoIbsMunicipal: value?.reducaoIbsMunicipal ?? 0,
                    valorCbs: value?.valorCbs ?? 0,
                    valorIbsEstadual: value?.valorIbsEstadual ?? 0,
                    valorIbsMunicipal: value?.valorIbsMunicipal ?? 0,
                    totalIbsCbs: value?.totalIbsCbs ?? 0,
                    valorBaseCalculoIbsCbs: value?.valorBaseCalculoIbsCbs ?? 0
                }

                this.calcularIbsCbsServico()
                this.applyEnquadramentoDependencies(this.objNf.enquadramento)
                await this.$nextTick()
                this.syncingFromParent = false
            },
            immediate: true
        },

        objNf: {
            handler(value){
                if (this.syncingFromParent) return
                this.$emit('nf', value)
            },
            deep: true,
            immediate: true
        },

        ['item.jobItensList']: {
            handler(jobItensList){
                if (this.syncingFromParent) return

                const jobItens = jobItensList?.map((item) => {
                    return {
                        ...item,
                        id: item?._id || item.id
                    }
                })

                const currentIds = Array.isArray(this.objNf.jobItens)
                    ? this.objNf.jobItens.map((item = {}) => this.resolveEntityId(item)).filter(Boolean).join(',')
                    : ''
                const nextIds = Array.isArray(jobItens)
                    ? jobItens.map((item = {}) => this.resolveEntityId(item)).filter(Boolean).join(',')
                    : ''

                if (currentIds === nextIds) return

                this.objNf.jobItens = jobItens
            },
            deep: true,
            immediate: true
        },

        ['item.job']: {
            async handler(job){
                if (!job) return
                if (this.syncingFromParent) return
                if (this.loadingJobItens) return

                const incomingJobId = this.resolveEntityId(job)
                if (incomingJobId && String(incomingJobId) === String(this.lastLoadedJobItensId) && this.dataItensJob.length > 0) {
                    return
                }

                await this.selectedJob(job)
            },
            deep: true,
            immediate: true
        },

        userInfo: {
            async handler(value){
                if (!value) return

                if(!value?.id){
                    if (typeof value !== 'string' || !value.trim()) return

                    const response = await Vue.prototype.$http.get(`/Entity/Cliente/${value}`)
                    this.objNf.destinatario = response.data.data
                    this.objNf.cpfOrCnpjTomador = response.data.data.cnpj
                    return
                }

                this.objNf.destinatario = value
                this.objNf.cpfOrCnpjTomador = value?.cnpj
                this.getCnpjInfo(value?.cnpj, 'Tomador')
            },
            deep: true,
            immediate: true
        },

        ['objNf.jobItens'](jobItens){
            if (jobItens.length > 1) {
                this.objNf.jobItens = [jobItens[jobItens.length - 1]]
                return
            }

            if(jobItens.length > 0){
                this.objNf.valorNf = 0 
                this.objNf.baseCalculo = 0

                jobItens?.map((item) => {
                    this.objNf.valorNf += item.precoTotal * 100
                    this.objNf.baseCalculo += item.precoTotal * 100
                })

                this.updtaeSum += 1
                this.calcImpostos()
                return
            }

            this.objNf.valorNf = 0 
            this.objNf.baseCalculo = 0
            this.calcularIbsCbsServico()
        },

        ['objNf.baseCalculo']() {
            if (this.isCalculatingImpostos) return
            this.calcImpostos()
        },

        ['objNf.valorNf']() {
            if (this.isCalculatingImpostos) return
            this.calcImpostos()
        },

        ['objNf.tributacaoMunicipal']() {
            this.calcImpostos()
        },

        ['objNf.enquadramento'](value) {
            this.applyEnquadramentoDependencies(value)
        },

        ['objNf.aliquota']() {
            this.calcImpostos()
        },

        ['objNf.dedutivel']() {
            this.calcImpostos()
        },

        ['objNf.informarIbsCbs']() {
            this.calcularIbsCbsServico()
        },

        ['objNf.aliquotaCbs']() {
            this.calcularIbsCbsServico()
        },

        ['objNf.aliquotaIbsEstadual']() {
            this.calcularIbsCbsServico()
        },

        ['objNf.aliquotaIbsMunicipal']() {
            this.calcularIbsCbsServico()
        },

        ['objNf.reducaoCbs']() {
            this.calcularIbsCbsServico()
        },

        ['objNf.reducaoIbsEstadual']() {
            this.calcularIbsCbsServico()
        },

        ['objNf.reducaoIbsMunicipal']() {
            this.calcularIbsCbsServico()
        },

        async ['objNf.id']() {
            try {
                await this.getEmitente()
            } catch (error) {
                console.error('[NF Serviço] Falha ao atualizar emitente por objNf.id:', error)
            }
        },

        parcelas: {
            handler(value){
                const totalParcelas = this.sumParcelasInCents()

                if ((!this.objNf.jobItens || this.objNf.jobItens.length === 0) && totalParcelas > 0) {
                    this.objNf.valorNf = totalParcelas
                    this.objNf.baseCalculo = totalParcelas
                    this.calcImpostos()
                }

                this.$emit('parcelas', value)
            },
            deep: true
        },

        valorNf(value){
            //this.totalNf = Number(value.replace(/\./g, '').replace(',', '.'))
            //this.calcImpostos()
        }
    },
    async created(){
        console.log('CREATED >>> ', this.objNf)
        try {
            if(!this.objNf.id){
                this.objNf.dataEmit = new Date().toISOString().split("T")[0]
                await this.getEmitente()
            }
        } catch (error) {
            console.error('[NF Serviço] Erro no created:', error)
        }
    },

    async mounted(){
        try {
            const response = await Promise.allSettled([
                this.getDataEntity("RegimeTributario"),
                this.getDataEntity("NotaFiscalServicoItemServicos"),
                this.getDataEntity("NotaFiscalServicoItemServicosNBS"),
                this.getDataEntity("NotaFiscalServicoItemServicosCST"),
                this.getDataEntity("NotaFiscalServicoItemServicosOperacaoIndicador"),
                this.getDataEntity("NotaFiscalServicoItemServicosClassificacaoTributaria"),
                this.getDataEntity("TipoDeEquipamento"),
                this.getDataEntity("TributacaoMunicipal"),
                this.getDataEntity("CNAE"),
                this.getNotaFiscalItemCST(),
                this.getNotaFiscalItemClassificacao()
            ])

            this.regimeTributarioList = response[0]?.status === 'fulfilled' ? response[0].value : []
            this.enquadramentoList = response[1]?.status === 'fulfilled' ? response[1].value : []
            this.nbsCadastroList = response[2]?.status === 'fulfilled' ? response[2].value : []
            this.cestCadastroList = response[3]?.status === 'fulfilled' ? response[3].value : []
            this.indicadorOperacaoCadastroList = response[4]?.status === 'fulfilled' ? response[4].value : []
            this.classificacaoTributariaCadastroList = response[5]?.status === 'fulfilled' ? response[5].value : []
            this.tipoEquipamentoList = response[6]?.status === 'fulfilled' ? response[6].value : []
            this.tributacaoList = response[7]?.status === 'fulfilled' ? response[7].value : []
            this.cnaeList = response[8]?.status === 'fulfilled' ? response[8].value : []
            this.fiscalCatalogsLoaded = true

            // Mantém referência para não quebrar integrações legadas no payload.
            this.nbsList = [...this.nbsCadastroList]

            this.applyEnquadramentoDependencies(this.objNf.enquadramento)

            this.calcImpostos()
            this.calcularIbsCbsServico()
        } catch (error) {
            console.error('[NF Serviço] Erro no mounted:', error)
            this.$notfy?.warning('Alguns dados auxiliares da NF de serviço não foram carregados.')
        }
    }
}
</script>